import ReactGA from 'react-ga4';

import authenticatedRequest from '../helpers/authenticatedRequest';
import { API } from '../../common';

const capturePaymentIntent = async ({ orderID }) => {
  ReactGA.event({
    category: 'Stripe',
    action: 'Capture payment intent',
  });

  try {
    const response = await authenticatedRequest(
      'post',
      `${API.stripe.capturePaymentIntent}`,
      {
        orderID,
      }
    );
    return { payment_intent_status: response?.data?.status };
  } catch (error) {
    console.error('Error during Payment intent capture', {
      error: error,
      payment_intent_status:
        error?.response?.data?.error?.payment_intent?.status,
    });
    return {
      error: error,
      payment_intent_status:
        error?.response?.data?.error?.payment_intent?.status,
    };
  }
};

export default capturePaymentIntent;
